module.exports = __webpack_public_path__ + "static/media/drum-puh-lop.958b05b8.webm";